export const SERVICE_RATING_KIND = 'service_rating';

export const SKIP_LABEL = '暂不评价';

export const SERVICE_QUESTION =
  '① 针对本次客服服务，你愿意给几星？（必填）';
export const RESOLUTION_QUESTION = '② 问题解决程度（选填）';
export const EXPERTISE_QUESTION = '③ 专业能力（选填）';
export const RESPONSIVENESS_QUESTION = '④ 响应与沟通体验（选填）';
export const COMMENT_QUESTION = '(5) 补充文字（选填）';
export const CATEGORY_QUESTION = '(6) 问题归类（必填）';

export const SERVICE_STARS = [
  { value: 1, label: '1星：非常不满意' },
  { value: 2, label: '2星：不满意' },
  { value: 3, label: '3星：一般' },
  { value: 4, label: '4星：满意' },
  { value: 5, label: '5星：非常满意' },
];

export const RESOLUTION_STARS = [
  { value: 1, label: '1星：完全没有推进，只是敷衍话术' },
  { value: 2, label: '' },
  { value: 3, label: '3星：给了答覆，但问题仍悬而未决' },
  { value: 4, label: '' },
  { value: 5, label: '5星：问题得到明确解决或清晰的后续路径' },
];

export const EXPERTISE_STARS = [
  { value: 1, label: '1星：明显不熟悉业务，答非所问' },
  { value: 2, label: '' },
  { value: 3, label: '3星：基本能答，但需要反复确认' },
  { value: 4, label: '' },
  { value: 5, label: '5星：准确、直接，能说清规则和依据' },
];

export const RESPONSIVENESS_STARS = [
  { value: 1, label: '1星：等待过久，或沟通让人不舒服' },
  { value: 2, label: '' },
  { value: 3, label: '3星：中规中矩' },
  { value: 4, label: '' },
  { value: 5, label: '5星：及时、清晰、不绕弯子' },
];

export const ISSUE_CATEGORIES = [
  '提现进度',
  '藏品/权益未到账',
  '功能异常',
  '客服不熟悉业务',
  '只是套话，没推进',
  '其他',
];

const DETAIL_FIELDS = [
  { key: 'resolution', title: '问题解决程度', options: RESOLUTION_STARS },
  { key: 'expertise', title: '专业能力', options: EXPERTISE_STARS },
  {
    key: 'responsiveness',
    title: '响应与沟通体验',
    options: RESPONSIVENESS_STARS,
  },
];

export function isCsatContentType(contentType) {
  return (
    contentType === 'input_csat' || contentType === 9 || contentType === '9'
  );
}

export function hasSubmittedRating(message) {
  const submitted = message?.content_attributes?.submitted_values;
  if (!submitted || Array.isArray(submitted)) return false;
  const response = submitted.csat_survey_response || submitted.csatSurveyResponse;
  return Number(response?.rating) >= 1;
}

export function serviceStarLabel(rating) {
  return (
    SERVICE_STARS.find(item => item.value === Number(rating))?.label || ''
  );
}

export function scoreDescription(options, value) {
  if (value === null || value === undefined || value === '') return '';
  const score = Number(value);
  if (!Number.isFinite(score)) return String(value);
  const band = score <= 2 ? 1 : score === 3 ? 3 : 5;
  const sentence = (options.find(item => item.value === band)?.label || '')
    .replace(/^\d+星[：:]/, '');
  if (sentence) return `${score}星：${sentence}`;
  return serviceStarLabel(value) || String(value);
}

export function parseServiceRating(feedback) {
  if (!feedback || typeof feedback !== 'string') return null;
  try {
    const data = JSON.parse(feedback);
    if (!data || data.kind !== SERVICE_RATING_KIND) return null;
    return data;
  } catch (error) {
    return null;
  }
}

export function serviceRatingLines(feedback) {
  const data = parseServiceRating(feedback);
  if (!data) return null;

  const lines = DETAIL_FIELDS.reduce((result, field) => {
    const value = data[field.key];
    if (value === null || value === undefined || value === '') return result;
    result.push({
      title: field.title,
      text: scoreDescription(field.options, value),
    });
    return result;
  }, []);

  if (data.category) {
    lines.push({ title: '问题归类', text: String(data.category) });
  }
  if (data.comment) {
    lines.push({ title: '补充文字', text: String(data.comment) });
  }
  return lines;
}

export function formatServiceRatingFeedback(feedback) {
  const lines = serviceRatingLines(feedback);
  if (!lines?.length) return null;
  return lines.map(line => `${line.title}：${line.text}`).join('；');
}

export function buildServiceRatingFeedback({
  resolution,
  expertise,
  responsiveness,
  comment,
  category,
  includeCategory,
}) {
  const payload = { kind: SERVICE_RATING_KIND };
  if (resolution) payload.resolution = resolution;
  if (expertise) payload.expertise = expertise;
  if (responsiveness) payload.responsiveness = responsiveness;
  const text = (comment || '').trim();
  if (text) payload.comment = text;
  if (includeCategory && category) payload.category = category;
  return JSON.stringify(payload);
}
